var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Processes the selection by taking the current selected indexes and adding the new selection to it or removing it if it's already in the selection
 *
 * @ignore
 * @param {PickerType} pickerType - The type of picker. Valid values: 'single', 'multiple'
 * @param {number[]} selectedIndexes - The currently selected indexes
 * @param {number} index - The index of the item that was clicked
 * @returns {number[]} - The updated selected items
 */
export default (function (pickerType, selectedIndexes, index) {
    if (pickerType === 'single') {
        if (selectedIndexes.indexOf(index) >= 0) {
            return [];
        }
        return [index];
    }
    if (selectedIndexes.indexOf(index) >= 0) {
        return selectedIndexes.filter(function (x) { return x !== index; });
    }
    return __spreadArray(__spreadArray([], selectedIndexes, true), [index], false).sort();
});
